module.exports = __webpack_public_path__ + "img/csv.5c180f7a.svg";